import React, { useEffect, useState } from 'react';

import { 
  Character,
  CharacterSheetInterface,
  Sense,
  SENSES,
} from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import FloatMenu from "@components/input/menus/FloatMenu";
import CharacterFeatureFromSource from "@dndComponents/character/features/CharacterFeatureFromSource";
import FlexBox from '@components/layout/FlexBox';
import CenteredMenu from '@components/input/menus/CenteredMenu';
import CharacterSenseCustomizations from '../customizations/CharacterSenseCustomizations';

interface Props {
  char: CharacterSheetInterface;
  disabled: boolean;
}

export default function CharacterSensesButton({ 
  char,
  disabled,
}: Props) {
  const [open, setOpen] = useState(false);
  const [reloading, setReloading] = useState(false);
  const [view, setView] = useState("Features");

  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderSenseFeatures = () => {
    const sense_features = char.mind.sense_features;
    return (
      <FlexBox direction="column">
        <FlexBox className="header">
          Sense Features
        </FlexBox>
        { sense_features.sort((a,b) => { return a.name.localeCompare(b.name) }).map((char_feature, key) => {
          const source = char.char_feature_sources.find(o => 
            o.true_id === char_feature.source_true_id);
          if (source) {
            return (
              <FlexBox key={key}>
                <CharacterFeatureFromSource
                  char={char}
                  obj={char_feature}
                  source={source}
                />
              </FlexBox>
            );
          }
          return null;
        })}
      </FlexBox>
    );
  }

  const renderSenseCustomizations = () => {
    return (
      <CharacterSenseCustomizations char={char} />
    );
  }

  const renderView = () => {
    switch(view) {
      case "Features": return renderSenseFeatures();
      default: return renderSenseCustomizations();
    }
  }

  const renderSensesInput = () => {
    const options = ["Features","Customizations"];
    return (
      <FlexBox direction="column">
        <FlexBox className="centered header">
          Manage Senses
        </FlexBox>
        <FlexBox>
          <CenteredMenu
            options={options}
            selected={view}
            onSelect={setView}
          />
        </FlexBox>
        { renderView() }
      </FlexBox>
    );
  }

  return (
    <>
      <FlexBox className={`centered header ${ disabled ? "" : "clickable"}`}
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        Senses
      </FlexBox>
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          char.subscription_holder.modalClosed();
        }}>
        { open && renderSensesInput() }
      </ModalOrDrawer>
    </>
  );
}
